var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38054",
    "data-name": "Group 38054",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14650",
    "data-name": "Rectangle 14650",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.618 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33385",
    "data-name": "Path 33385",
    d: "M14.81,14.155l-3.036-3.036a5.573,5.573,0,1,0-.655.655l3.036,3.036a.463.463,0,1,0,.655-.655ZM2.9,7.532a4.634,4.634,0,1,1,4.634,4.634A4.634,4.634,0,0,1,2.9,7.532Z",
    transform: "translate(-1.946 -1.946)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoup);
export default __webpack_public_path__ + "static/media/loup.53317cf7b603ed5b0d265882508bb78e.svg";
export { ForwardRef as ReactComponent };